import {PubNubSettings} from "../model/settings/Settings";
import {Option, option} from "ts-option";
import moment = require("moment");

const PubNub = require("pubnub");

class PubNubService {
	private instance?: any;

	constructor() {}

	init(settings: PubNubSettings, userId: string) {
		this.instance = new PubNub({
			publishKey: settings.pubnubPublishKey,
			subscribeKey: settings.pubnubSubscribeKey,
			uuid: userId
		})
	}

	subscribe(jobCreatorId: string) {
		this.instance && this.instance.subscribe({
			channels: [this.getChannelName(jobCreatorId)],
			withPresence: true,
		})
	}

	unsubscribe(jobCreatorId: string) {
		this.instance && this.instance.unsubscribe({
			channels: [this.getChannelName(jobCreatorId)],
		})
	}

	addPresenceListener(jobCreatorId: string, callback: (isActive: boolean, lastSeen?: Option<moment.Moment>) => void) {
		const listener: any = {
			status: (response: any) => {
				if (response.category === "PNConnectedCategory") {
					response.affectedChannels.forEach((channel: string) => {
						this.instance.hereNow({
							channel,
							includeUUIDs: true,
							includeState: true
						}, (status: any, response: any) => {
							if (response) {
								const channel = response.channels[this.getChannelName(jobCreatorId)];
								channel && channel.occupants.forEach((occ: any) => {
									if (occ.uuid === jobCreatorId) {
										callback(true, option(moment()));
									}
								})
							}
						})
					})
				}
			},
			message() { },
			presence: (response: any) => {
				if (response.action === "join") {
					if (response.uuid && response.uuid === jobCreatorId) {
						callback(true, option(moment.unix(response.timestamp)));
					}
				}
				if (response.action === "interval") {
					if (response.join !== undefined) {
						for (let i = 0; i < response.occupancy; i++) {
							if (response.join[i] !== undefined) {
								if (jobCreatorId === response.join[i]) {
									callback(true, option(moment.unix(response.timestamp)));
								}
							}
						}
					}

					if (response.leave !== undefined) {
						for (let i = 0; i < response.occupancy; i++) {
							if (jobCreatorId === response.leave[i]) {
								callback(false);
							}
						}
					}
				}
				if (response.action === "leave") {
					if (jobCreatorId === response.uuid) {
						callback(false);
					}
				}
				if (response.action == "timeout") {
					if (jobCreatorId === response.uuid) {
						callback(false)
					}
				}
			},
			signal: (status: any) => {
				if (status.publisher === jobCreatorId) {
					callback(true, option(moment.unix(status.timetoken.substr(0, 10))))
				}
			}
		};
		this.instance && this.instance.addListener(listener);
	}

	private getChannelName(jobCreatorId: string) {
		return `${jobCreatorId}_presence_channel`
	}
}

export default new PubNubService();